import React from 'react'
import IamApolloClient from 'common/clients/IamApolloClient'
import { ApolloProvider } from '@apollo/client'

export default (props: any) => <ApolloProvider client={IamApolloClient}>{props.children}</ApolloProvider>
